<script setup>
import { ref, reactive, onMounted, computed } from "vue";
import { Search, Delete } from "@element-plus/icons-vue";
import { deviceList, updateDevice, productList } from "@/api/device";
import { groupPage, createGroup, deleteGroup } from "@/api/group";
import { ElMessage, ElMessageBox } from "element-plus";
import { FormInstance } from "element-plus";
import { parseTime } from "@/utils/ruoyi";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import en from "element-plus/dist/locale/en.mjs";
import trTr from "element-plus/dist/locale/tr.mjs";
import ru from "element-plus/dist/locale/ru.mjs";
const { locale } = useI18n();
const language = ref(locale);
const locales = computed(() => {
  switch (language.value) {
    case "zh-cn":
      return zhCn;
    case "en":
      return en;
    case "tr-tr":
      return trTr;
      case "ru-ru":
      return ru;
    default:
      return en; // 默认返回英语
  }
});
const SearchIcon = Search;
const DeleteIcon = Delete;
import { useI18n } from "vue-i18n";

// 引入i18n用于国际化
const { t } = useI18n();

const products = ref(null);

// 获取产品列表
const getProduct = () => {
  productList().then((res) => {
    if (res && res.data) {
      // 使用reduce将数组转换为对象
      products.value = res.data.reduce((acc, item) => {
        acc[item.id] = item.productName;
        return acc;
      }, {});

      console.log(products.value);
    }
  });
};

// 场景form
const ruleFormGroup = reactive({
  groupName: "",
  groupStatus: "",
});

// 场景搜索
const groupParams = reactive({
  groupName: "",
});

// 场景创建规则
const rulesGroup = computed(() => ({
  groupName: [
    { required: true, message: t("group.inputGroupName"), trigger: "blur" },
  ],
  groupStatus: [
    {
      required: true,
      message: t("group.selectGroupState"),
      trigger: "change",
    },
  ],
}));

const groupFormRef = ref();
const ruleFormRef = ref();

const groupList = ref([]);
const deviceListData = ref([]);
const groupDialogVisible = ref(false);

const background = ref(true);
const disabled = ref(false);

const deviceParams = reactive({
  pageNo: 1,
  pageSize: 10,
  deviceName: "",
});

const total = ref(1000);
const dialogVisible = ref(false);

const deviceForm = reactive({
  name: "",
});

const rules = reactive({
  deviceName: [
    { required: true, message: t("group.inputDeviceName"), trigger: "blur" },
  ],
  noteName: [
    { required: true, message: t("device.noteNameTip"), trigger: "blur" },
  ],
});

// 获取组列表
const getGroupList = (params) => {
  groupPage(params).then((res) => {
    if (res && res.data && res.data.list) {
      groupList.value = res.data.list;
    }
  });
};

// 获取设备列表
const getDeviceList = (params) => {
  deviceList(params).then((res) => {
    if (res && res.data && res.data.list) {
      deviceListData.value = res.data.list;
      console.log(" = 设备列表", deviceListData.value);
      total.value = res.data.total;
      getProduct();
    }
  });
};

const edit = (row) => {
  console.log(" - 编辑", row);
  dialogVisible.value = true;
  Object.assign(deviceForm, row);
};

const handleSizeChange = (val) => {
  console.log(`${val} items per page`);
  deviceParams.pageSize = val;
  getDeviceList(deviceParams);
};

const handleCurrentChange = (val) => {
  console.log(`current page: ${val}`);
  deviceParams.pageNo = val;
  getDeviceList(deviceParams);
};
// 关闭编辑设备对话框
const handleClose = () => {
  dialogVisible.value = false;
};

// 关闭场景新增/编辑对话框
const handleCloseGroup = () => {
  groupDialogVisible.value = false;
};

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log("submit!");
      console.log(" = submit", deviceForm);
      updateDevice(deviceForm)
        .then((res) => {
          console.log(" - res", res);
          dialogVisible.value = false;
          ElMessage({
            message: t("group.editSuccess"),
            type: "success",
          });
          getDeviceList(deviceParams);
        })
        .catch((err) => {
          ElMessage({
            message: t("group.editFail"),
            type: err,
          });
        });
    } else {
      console.log("error submit!", fields);
    }
  });
};

const submitFormGroup = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log("submit!");
      ElMessageBox.confirm(t("group.confirmSubmission"), t("group.tip"), {
        confirmButtonText: t("group.confirm"),
        cancelButtonText: t("group.cancel"),
        type: "warning",
      })
        .then(() => {
          createGroup(ruleFormGroup)
            .then(() => {
              ElMessage({
                type: "success",
                message: t("group.addSuccess"),
              });
              groupDialogVisible.value = false;
              getGroupList({});
            })
            .catch(() => {
              ElMessage({
                type: "error",
                message: t("group.addFail"),
              });
              groupDialogVisible.value = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: t("group.cancel"),
          });
        });
    } else {
      console.log("error submit!", fields);
    }
  });
};

// 通过设备名称搜索
const selectDevice = () => {
  console.log(" 设备名称搜索设备 : ", deviceParams);
  getDeviceList(deviceParams);
};
// 通过场景名称搜索场景
const selectGroup = () => {
  console.log(" = 搜索场景", groupParams.groupName);
  getGroupList(groupParams);
};

// 打开创建场景
const openCreateGroup = () => {
  groupDialogVisible.value = true;
};
// 删除场景
const handleDeleteGroup = (item) => {
  ElMessageBox.confirm(t("group.sureDeleteScene"), t("group.tip"), {
    confirmButtonText: t("group.confirm"),
    cancelButtonText: t("group.cancel"),
    type: "warning",
  })
    .then(() => {
      deleteGroup({ id: item.id }).then(() => {
        ElMessage({
          type: "success",
          message: t("group.successDelete"),
        });
        getGroupList({});
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: t("group.undelete"),
      });
    });
};

onMounted(() => {
  getDeviceList({});
  getGroupList({});
});
</script>

<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-3 col-3">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h6>{{ $t("group.groupList") }}</h6>
          </div>
          <div class="card-body">
            <el-input
              v-model="groupParams.groupName"
              style="width: 100%"
              :placeholder="$t('group.search')"
              :prefix-icon="Search"
              @input="selectGroup"
            />

            <div
              style="height: 90%"
              class="d-flex flex-column align-content-between justify-content-between"
            >
              <div class="mt-5" v-if="groupList && groupList.length === 0">
                <div class="group-item p-2 mt-1">
                  <div>{{ $t("group.defaultGroup") }}</div>
                </div>
              </div>

              <div class="mt-5" v-if="groupList && groupList.length > 0">
                <div
                  class="group-item p-2 mt-1"
                  v-for="(item, index) in groupList"
                  :key="index"
                >
                  <div>{{ item.groupName }}</div>
                  <el-icon @click="handleDeleteGroup(item)"><Delete /></el-icon>
                </div>
              </div>
              <el-button type="primary" @click="openCreateGroup">{{
                $t("group.newScene")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-8">
        <!-- 场景编辑 -->
        <el-dialog
          v-model="groupDialogVisible"
          :title="$t('group.edit')"
          width="60%"
          :before-close="handleCloseGroup"
        >
          <el-form
            ref="groupFormRef"
            style="max-width: 600px"
            :model="ruleFormGroup"
            :rules="rulesGroup"
            label-width="auto"
            class="demo-ruleForm"
            status-icon
          >
            <el-form-item :label="$t('group.sceneName')" prop="groupName">
              <el-input v-model="ruleFormGroup.groupName" />
            </el-form-item>
            <el-form-item :label="$t('group.sceneState')" prop="groupStatus">
              <el-select
                v-model="ruleFormGroup.groupStatus"
                :placeholder="$t('group.selectGroupState')"
              >
                <el-option :label="$t('group.usable')" value="1" />
                <el-option :label="$t('group.forbidden')" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitFormGroup(groupFormRef)">
                {{ $t("group.submit") }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!--编辑设备-->
        <el-dialog
          v-model="dialogVisible"
          :title="$t('group.edit')"
          width="60%"
          :before-close="handleClose"
        >
          <el-form
            ref="ruleFormRef"
            style="max-width: 600px"
            :model="deviceForm"
            :rules="rules"
            label-width="auto"
            class="demo-ruleForm"
            status-icon
          >
            <!--            <el-form-item label="归属产品" prop="name">-->
            <!--              <el-input v-model="deviceForm.name" />-->
            <!--            </el-form-item>-->
            <el-form-item :label="$t('device.devicename')" prop="deviceName">
              <el-input v-model="deviceForm.deviceName" disabled />
            </el-form-item>

            <el-form-item :label="$t('device.noteName')" prop="noteName">
              <el-input v-model="deviceForm.noteName" />
            </el-form-item>

            <el-form-item :label="$t('device.homeGroup')" prop="groupId">
              <el-select
                v-model="deviceForm.groupId"
                :placeholder="$t('device.homeGroup')"
              >
                <el-option
                  v-for="(item, index) in groupList"
                  :key="index"
                  :label="item.groupName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('device.longitude')" prop="longitude">
              <el-input v-model="deviceForm.longitude" />
            </el-form-item>

            <el-form-item :label="$t('device.latitude')" prop="latitude">
              <el-input v-model="deviceForm.latitude" />
            </el-form-item>
          </el-form>
          <el-form-item>
            <el-button type="primary" @click="submitForm(ruleFormRef)">
              {{ $t("group.submit") }}
            </el-button>
          </el-form-item>
        </el-dialog>

        <div class="card h-100">
          <div
            class="card-header pb-0 d-flex align-items-center justify-content-between"
          >
            <h6>{{ $t("home.deviceList") }}</h6>
            <div>
              <el-input
                v-model="deviceParams.deviceName"
                style="width: 180px"
                :placeholder="$t('device.deviceNameSearch')"
                :prefix-icon="Search"
              />
              <el-button class="m-1" type="primary" @click="selectDevice">{{
                $t("group.search")
              }}</el-button>
            </div>
          </div>
          <div class="card-body">
            <el-table :data="deviceListData" style="width: 100%">
              <el-table-column :label="$t('device.equipmentInformation')">
                <template #default="scope">
                  <div class="">
                    <div class=" ">
                      <div>{{ scope.row.deviceName }}</div>
                      <div class="m-lg-3">
                        <el-tag
                          type="success"
                          v-if="scope.row.onlineState === 1"
                          >{{ $t("home.onLine") }}</el-tag
                        >
                        <el-tag
                          type="danger"
                          v-if="scope.row.onlineState === 0"
                          >{{ $t("home.offLine") }}</el-tag
                        >
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="noteName" :label="$t('device.noteName')">
                <template #default="scope">
                  {{ scope.row.noteName }}
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                :label="$t('device.creationTime')"
              >
                <template #default="scope">
                  {{ parseTime(scope.row.createTime) }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('device.operation')">
                <template #default="scope">
                  <el-link @click="edit(scope.row)">{{
                    $t("group.edit")
                  }}</el-link>
                </template>
              </el-table-column>
            </el-table>
            <el-config-provider :locale="locales">
              <div class="p-3 d-flex align-items-center justify-content-end">
                <el-pagination
                  v-model:current-page="deviceParams.pageNo"
                  v-model:page-size="deviceParams.pageSize"
                  :page-sizes="[10, 100, 200, 300, 400]"
                  :disabled="disabled"
                  :background="background"
                  layout="sizes, prev, pager, next"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </div>
            </el-config-provider>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 row">
      <div class="col-12">
        <!--        <projects-table />-->
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.group-item {
  width: 100%;
  height: auto;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f8fc;
}
.group-item:hover {
  border: 1px solid #089b5c;
}
</style>
